import apiservice from '@/services/request'

// 查詢網站選項 Get Option
// ex: locale, language, currency...等
export const getOption = (type = 'array', keys = '') => {
  return apiservice({
    url: '/misc/getOption',
    method: 'get',
    params: {
      structure: type,
      keys
    }
  })
}

// 查詢地區 Get Location
// 不帶參:查國家
// 帶 id 參數: 查該國家的地區
export const getLocationOption = (code: any = '', structure = 'array') => {
  return apiservice({
    url: '/misc/getLocationOption',
    method: 'get',
    params: {
      code,
      structure
    }
  })
}

/**
 * Get Locale 語系資料
 * @returns json data
 */
export const getLocale = () => {
  return apiservice({
    url: '/misc/getLocale',
    method: 'get'
  })
}

/**
 * Get Category Option
 * @param code 無:回傳大分類, 有:回傳細項
 * @param structure 回傳的結構, 'object' or 'array'
 * @returns json data
 */
export const getCategoryOption = (code = '', structure = 'array') => {
  return apiservice({
    url: '/misc/getCategoryOption',
    method: 'get',
    params: {
      code,
      structure
    }
  })
}

/**
 * 取得問題代碼
 * @param structure 回傳的結構, 'object' or 'array'
 * @returns json data
 */
export const getRequestQuestionOption = (structure = 'array') => {
  return apiservice({
    url: '/misc/getRequestQuestionOption',
    method: 'get',
    params: {
      structure
    }
  })
}

/**
 * 取得時區
 * @param code 輸入區域>該區域的時區, 空字串>主要區域大象
 * @param structure 回傳的結構, 'object' or 'array'
 * @returns JSON Data
 */
export const getTimezoneOption = (code = '', structure = 'array') => {
  return apiservice({
    url: '/misc/getTimezoneOption',
    method: 'get',
    params: {
      code,
      structure
    }
  })
}
